export default {
  title: 'Twoja opinia naprawdę pomaga ❤️',
  description: '{{name}} w {{store}} — wystarczy dotknąć gwiazdki',
  buttons: {
    not_now: 'Nie teraz',
    continue: 'Kontynuuj',
  },
};
